/**
 * File Upload Showcase Page
 *
 * This page demonstrates file upload widget types available in the RUL form system.
 *
 * Route: /apps/examples/forms/file-upload-showcase
 */

import { message } from 'antd';
import { UniversalRULForm } from '@/components/features/rul/UniversalRULForm';
import './FileUploadShowcasePage.css';

export const FileUploadShowcasePage: React.FC = () => {
  const handleSuccess = (data: any) => {
    message.success('Form validated successfully!');
    console.log('Form submitted:', data);
  };

  const handleError = (errors: Record<string, string>) => {
    message.error('Please fix validation errors');
    console.error('Validation errors:', errors);
  };

  return (
    <div className="file-upload-showcase-page">
      <div className="file-upload-showcase-container">
        <UniversalRULForm
          formUrl="/formsexamples/rul/forms/file_upload_showcase"
          onSuccess={handleSuccess}
          onError={handleError}
          className="file-upload-showcase-form"
          debounceMs={500}
        />
      </div>
    </div>
  );
};
